import { FeedbackGroupState } from '../types/feedback/FeedbackGroup';

/**
 * The list of customer feedback group states that our application cares about.
 * We can include this list in our request to ORCA to act as a filter so that it only
 * returns groups in the states that we wish to process in ODUI.
 */

export const customerFeedbackGroupStatesFilter = [
  FeedbackGroupState.AWAITING_FEEDBACK,
];
